import { render } from "./Bollettini.vue?vue&type=template&id=2bc95d86&ts=true"
import script from "./Bollettini.vue?vue&type=script&lang=ts"
export * from "./Bollettini.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__